/**
 * @description Hook utilizado para manipular as regionais
 * @author Diego Sabino Amorim de Araújo
 * @file useRegionalService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useDispatch } from 'react-redux'
import actionTypes from 'utils/actionTypes'
import { useFetch } from './useFetch'

export const useRegionalService = () => {
  const fetch = useFetch()
  const dispatch = useDispatch()

  const listarRegionaisDeOrgaoGlobal = async (idOrgao, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`orgaos/${idOrgao}/regionais/`)
      dispatch({
        type: actionTypes.FETCH_REGIONAIS,
        regionais: response.data.regionaisOrgao,
      })
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRegionalAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/orgao/regionais/${id}`)
      return response.data.regional
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarRegionaisAnuncio = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/orgao/regionais/regionaistodos`)
      return response.data.regionais
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarRegional = async (dados, idOrgao, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const novaRegional = {
        nome: dados.nome,
        sigla: dados.sigla,
        descricao: dados.descricao,
        orgao: idOrgao,
      }
      await fetch.postOpen('/orgao/regionais/', novaRegional)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const editarRegional = async (id, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const regional = {
        id: dados.id,
        nome: dados.nome,
        sigla: dados.sigla,
        descricao: dados.descricao,
        orgao: dados.orgao,
      }
      await fetch.putOpen(`/orgao/regionais/${id}/`, regional)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const deletarRegional = async (id, setProcessando) => {
    if (setProcessando) setProcessando(true)
    await fetch.del(`/orgao/regionais/${id}/`)
    if (setProcessando) setProcessando(false)
  }

  return {
    listarRegionaisDeOrgaoGlobal,
    listarRegionalAsync,
    deletarRegional,
    cadastrarRegional,
    editarRegional,
    listarRegionaisAnuncio,
  }
}
